import { render, staticRenderFns } from "./PreviousWinnerSection.vue?vue&type=template&id=1d68be72&"
import script from "./PreviousWinnerSection.vue?vue&type=script&lang=js&"
export * from "./PreviousWinnerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports